import styled from "styled-components";

export const AuditContainer = styled.section`
  /* width: 100%; */
  padding: 10px 25px;
  box-sizing: border-box;
  margin: 20px 20px;

  .heading {
    background-color: white;
    padding-top: 10px;

    padding-left: 10px;
    padding-right: 10px;
    border-radius: 8px;
    color: #2f4f4f;

    h4 {
      color: #2f4f4f !important;
    }
  }
`;

export const AuditListWrapper = styled.div`
  margin-top: 15px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
`;
